export default "__VITE_ASSET__TyF0GvUU__"